import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getPhseWisePatient,
  setFilterLocation,
  setPatientListStartPage,
  setSelectedPhase,
} from "redux/reducers/Dashboard/dashboard.slice";
import { ArrowRightOutlined } from "@ant-design/icons";
import { Col } from "react-bootstrap";

const phaseClass = {
  1: "orange-arrow",
  2: "green-arrow",
  3: "blue-arrow",
  4: "purple-arrow",
};

const PhaseCountCard = memo(({ count, percent, thisWeekCount, phase }) => {
  const dispatch = useDispatch();
  const { selectedLocation } = useSelector(({ role }) => role);
  const { selectedPhase, filterLocation } = useSelector(
    ({ dashboard }) => dashboard
  );

  const onPhaseClick = () => {
    const payload = {
      filter_location_id: selectedLocation,
      phase: Array.from(String(phase), Number),
    };

    dispatch(
      getPhseWisePatient({
        location_id: selectedLocation,
        start: 1,
        limit: 10,
        payload,
      })
    );

    dispatch(setSelectedPhase(phase));
    dispatch(setFilterLocation(selectedLocation));
    dispatch(setPatientListStartPage(1));
  };

  return (
    <Col lg={3} md={6} className="home_card_item">
      <div
        className="card_item d-flex align-items-center"
        onClick={
          selectedPhase === phase && selectedLocation === filterLocation
            ? null
            : onPhaseClick
        }
      >
        <div className="card_number">
          <h2 className="m-0">{count}</h2>
        </div>
        <div className="card_description">
          <p className="m-0 main_title">
            {phase === 4 ? "Completed patient" : `Phase ${phase} patient`}
          </p>
          <p className="m-0 sub_title">
            {percent ? Math.abs(percent) : thisWeekCount}
            {`${percent ? "% " : " "}`}
            {percent
              ? `${percent > 0 ? "Increase" : "Decrease"} from last week`
              : "Patient in this week"}
          </p>
        </div>
        <div className="right_arrow_image">
          <ArrowRightOutlined className={phaseClass[phase]} />
        </div>
      </div>
    </Col>
  );
});

export default memo(PhaseCountCard);
